<template>
  <div style="background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);;">
    <Header :jifen="jifen" />
<!--    <mall-header :showSearch="false"  />-->
    <div id="mall-index" style="background-color: #f9f7f7;">
      <div class="clearfix">
        <div class="fruit_list">
          <goods-module :goodsList="goodsList" :total="total" @paginationChange="paginationChange"/>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import GoodsModule from './modules/GoodsModule.vue'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import MallHeader from './modules/Header'
import {loadCompanyGoods, loadGoodsAvailablePoints} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";

export default {
  components: {
    GoodsModule,
    Header,
    Footer,
    MallHeader
  },
  mixins: [fileUrlMixin],
  data () {
    return {
      jifen: 0,
      goodsList: [],
      total: 0,
      current: 1,
      params: {
        size: 8,
        current: 1,
        name: ''
      },
      supplierList: []
    }
  },
  mounted() {
    this.getGoods()
  },
  methods: {
    getloadGoodsAvailablePoints (d) {
      loadGoodsAvailablePoints(d).then(res => {
        this.jifen = res.data?.points || 0
      })
    },
    getGoods () {
      loadCompanyGoods({ query: {...this.params}, companyId: this.$route.query.id}).then(res =>{
        this.goodsList  = res.data.records
        this.total  = res.data.total
        this.getloadGoodsAvailablePoints({ supplierCompanyId: this.$route.query.id })
      })
    },
    paginationChange (key) {
      this.params.current = key
      this.getGoods()
    }
  }
}
</script>

<style lang="less" scoped>
#mall-index {
  width: 1200px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);;
}
.clearfix {
  display: flex;
}
.supplier-card {
  width: 15%;
  margin-right: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  .card-title{
    background-color: #f3f3f3;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: 600;
  }
  .card-content {
    min-height: 650px;
    padding: 0 5px;
  }
  .item-card{
    padding: 10px;
    border-bottom: 1px dashed #e6e6e6;
    font-weight: 550;
    p{
      font-size: 13px;
    }
    .supplierName{
      font-size: 15px;
    }
    .contactNumber {
      word-break: break-all;
    }
    &:last-child{
      border: none;
    }
  }
}
.fruit_list{
  flex: 1;
  margin-top: 20px;
}
</style>
